import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Grid, withStyles } from '@material-ui/core';

import { LabelName, Required } from '../../../../../utils';

const CustomCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#00B6A4',
    },
  },
  checked: {},
})(Checkbox);

export function CheckBox({ data, setData, setError, ind, isRequired, globalStateData }) {
  const [selectedValues, setSelectedValues] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue ?? [],
  );

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  useEffect(() => {
    setError(null);

    if (isRequired && selectedValues.length === 0) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }

    setData(selectedValues, ind);
  }, [selectedValues]);

  const handleChange = (option) => {
    setSelectedValues((prev) =>
      prev.includes(option) ? prev.filter((item) => item !== option) : [...prev, option],
    );
  };

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>
      <Grid item>
        <FormGroup style={{ display: 'flex', flexDirection: 'row', marginLeft: '5px' }}>
          {data?.checkBoxOptions?.map((option) => (
            <FormControlLabel
              key={option}
              control={
                <CustomCheckbox
                  checked={selectedValues.includes(option)}
                  onChange={() => handleChange(option)}
                  disabled={isDisabled}
                />
              }
              label={option}
            />
          ))}
        </FormGroup>
      </Grid>
    </Grid>
  );
}

export default CheckBox;
